import {
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  Select,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  InputAdornment,
  IconButton,
  Modal,
  Box,
  Autocomplete,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import user from "../../assets/user.gif";
import DaterangePicker from "../../common/Daterangepicker";
import commonapihandler from "../../common/commonapihandler";
import { BlinkBlur } from "react-loading-indicators";
import {
  getDeliveryAgentsList,
  getPickupAgentsList,
  getHubName,
} from "../../api/api";
import formatDate from "../../common/Formatdate";
import { useNavigate } from "react-router-dom";

function createData(
  // bookingid,
  bookingcode,
  bookingstatus,
  city,
  bookfrom,
  bookto,
  agentname,
  agentemail,
  assigneename,
  createdAt,
  action
) {
  return {
    // bookingid,
    bookingcode,
    bookingstatus,
    city,
    bookfrom,
    bookto,
    agentname,
    agentemail,
    assigneename,
    createdAt,
    action,
  };
}

function createDataForPickup(
  // bookingid,
  bookingcode,
  bookingstatus,
  city,
  bookfrom,
  bookto,
  agentname,
  agentemail,
  assigneename,
  createdAt,
  action
) {
  return {
    // bookingid,
    bookingcode,
    bookingstatus,
    city,
    bookfrom,
    bookto,
    agentname,
    agentemail,
    assigneename,
    createdAt,
    action,
  };
}

const Deliverypickupagentdashboard = () => {
  const profile = JSON.parse(localStorage.getItem("profile"));
  const fuelTypes = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  //const status = JSON.parse(localStorage.getItem("status"));
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [cities, setCities] = useState(null);
  const [city, setCity] = useState("");
  const [hubs, setHubs] = useState(null);
  const [hub, setHub] = useState("");
  // For Delivery
  const [deliveryPage, setDeliveryPage] = useState(0);
  const [deliveryRowsPerPage, setDeliveryRowsPerPage] = useState(10);
  const [deliveryTotalCount, setDeliveryTotalCount] = useState(0);
  const [deliveryAgentList, setDeliveryAgentList] = useState([]);
  // For Pickup
  const [pickupAgentList, setPickupAgentList] = useState([]);

  // For Pickup
  const [pickupPage, setPickupPage] = useState(0);
  const [pickupRowsPerPage, setPickupRowsPerPage] = useState(10);
  const [pickupTotalCount, setPickupTotalCount] = useState(0);

  const [selectedRow, setSelectedRow] = useState(null);
  const [openTab, setOpenTab] = useState(false);
  const [totalCount, setTotalCount] = useState(0); // for total rows from backend
  const [systemUserData, setSystemUserData] = useState([]);
  const [executiveId, setExecutiveId] = useState(null);
  const [loadingDelivery, setLoadingDelivery] = useState(false);
  const [loadingPickup, setLoadingPickup] = useState(false);
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.fleetBookingStatus;

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const columns = [
    // { id: "bookingid", label: "Booking Id", minWidth: 60 },
    { id: "bookingcode", label: "Booking Code", minWidth: 150 },
    { id: "bookingstatus", label: "Booking Status", minWidth: 190 },
    { id: "city", label: "City", minWidth: 190 },
    { id: "bookfrom", label: "Book From", minWidth: 130 },
    { id: "bookto", label: "Book To", minWidth: 150 },
    { id: "agentname", label: "Agent Name", minWidth: 130, align: "right" },
    { id: "agentemail", label: "Agent Email", minWidth: 60 },
    {
      id: "assigneename",
      label: "Assignee Name",
      minWidth: 150,
      align: "right",
    },
    { id: "createdAt", label: "Created At", minWidth: 120, align: "right" },
    { id: "action", label: "Action", minWidth: 90, align: "right" },
  ];

  const rows =
    deliveryAgentList?.map((item) =>
      createData(
        // item?.bookingId ? item?.bookingId : "N/A",
        item?.bookingCode,
        fleetBookingStatus[item?.bookingDetails?.bookingStatus] || "-",
        cities?.[item?.cityId] || "-",
        formatDate(item?.bookFrom),
        formatDate(item?.bookTo),
        item?.agentName,
        item?.agentEmail,
        item?.assigneeName,
        formatDate(item?.createdAt),
        item?.billNo,
        "View"
      )
    ) || [];

  const pickAgentsListData =
    pickupAgentList?.map((item) =>
      createDataForPickup(
        // item?.bookingId ? item?.bookingId : "N/A",
        item?.bookingCode,
        fleetBookingStatus[item?.bookingDetails?.bookingStatus] || "-",
        cities?.[item?.cityId] || "-",
        formatDate(item?.bookFrom),
        formatDate(item?.bookTo),
        item?.agentName,
        item?.agentEmail,
        item?.assigneeName,
        formatDate(item?.createdAt),
        item?.billNo,
        "View"
      )
    ) || [];

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setOpenTab(true);
  };

  const getCityNames = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/cities/indexify`);
      const data = await response.json();
      if (data) setCities(data);
    } catch (error) {
      console.error("Error fetching City Names:", error);
    }
  };

  const handleCityChange = (event) => {
    const value = event.target.value;
    setCity(value);
    getHubNames(value);
  };

  const handleHubChange = (event) => {
    setHub(event.target.value);
  };

  // Delivery Table
  const handleDeliveryChangePage = (event, newPage) => {
    setDeliveryPage(newPage);
    getdeliveryAgentListApi(newPage, deliveryRowsPerPage);
  };

  const handleDeliveryChangeRowsPerPage = (event) => {
    const newRows = +event.target.value;
    setDeliveryRowsPerPage(newRows);
    setDeliveryPage(0);
    getdeliveryAgentListApi(0, newRows);
  };

  // Pickup Table
  const handlePickupChangePage = (event, newPage) => {
    setPickupPage(newPage);
    getPickupAgentListApi(newPage, pickupRowsPerPage);
  };

  const handlePickupChangeRowsPerPage = (event) => {
    const newRows = +event.target.value;
    setPickupRowsPerPage(newRows);
    setPickupPage(0);
    getPickupAgentListApi(0, newRows);
  };

  const getHubNames = async (value) => {
    const apiDetails = await getHubName(value);
    const data = await commonapihandler(apiDetails?.apiUrl, apiDetails?.method);
    setHubs(data?.entities?.rows || []);
  };

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formatStartDate = formatDateForApi(selectionRange?.startDate);
  const formatEndDate = formatDateForApi(selectionRange?.endDate);

  const getdeliveryAgentListApi = async (
    customPage = deliveryPage,
    customRowsPerPage = deliveryRowsPerPage
  ) => {
    const offset = customPage * customRowsPerPage;
    let query = `limit=${customRowsPerPage}&offset=${offset}&startDate=${formatStartDate}&endDate=${formatEndDate}`;
    if (city && hub) query += `&cityId=${city}&hubId=${hub}`;
    if (executiveId) query += `&agentId=${executiveId?.id}`;
    setLoadingDelivery(true);
    const apiDetails = await getDeliveryAgentsList(query);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method
    );
    if (response?.statusCode === "0100") {
      setLoadingDelivery(false);
      setDeliveryAgentList(response?.entities?.rows);
      setDeliveryTotalCount(response?.entities?.count || 0);
    }
  };

  const getPickupAgentListApi = async (
    customPage = pickupPage,
    customRowsPerPage = pickupRowsPerPage
  ) => {
    const offset = customPage * customRowsPerPage;
    let query = `limit=${customRowsPerPage}&offset=${offset}&startDate=${formatStartDate}&endDate=${formatEndDate}`;
    if (city && hub) query += `&cityId=${city}&hubId=${hub}`;
    if (executiveId) query += `&agentId=${executiveId?.id}`;
    setLoadingPickup(true);
    const apiDetails = await getPickupAgentsList(query);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method
    );
    if (response?.statusCode === "0100") {
      setLoadingPickup(false);
      setPickupAgentList(response?.entities?.rows);
      setPickupTotalCount(response?.entities?.count || 0);
    }
  };

  useEffect(() => {
    getCityNames();
    getdeliveryAgentListApi();
    getSystemUser();
    getPickupAgentListApi();
  }, []);

  function formatDateForApi(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  const formattedStartDate = formatDateForApi(selectionRange?.startDate);
  const formattedEndDate = formatDateForApi(selectionRange?.endDate);

  const getSystemUser = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=1000&isSystemUser=${1}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setSystemUserData(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleReset = () => {
    // Reset filters and pagination, but preserve executiveId
    setCity("");
    setHub("");
    setSelectionRange({
      startDate: oneMonthAgo,
      endDate: today,
      key: "selection",
    });
    setDeliveryPage(0);
    setPickupPage(0);

    setTimeout(() => {
      getdeliveryAgentListApi(0, deliveryRowsPerPage);
      getPickupAgentListApi(0, pickupRowsPerPage);
    }, 0);
  };


  return (
    <>
      <div className="h-full backdrop-blur-sm sm:px-6 md:px-0 max-w-screen-xl">
        <>
          <>
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-6 mt-4 w-full">
              <div className="flex items-center gap-4">
                <img className="w-20 h-20 rounded-full" src={user} alt="User" />
                <h1 className="text-xl sm:text-2xl font-bold break-words">
                  Welcome back, {profile?.name}!
                </h1>
              </div>
            </div>

            {/* Filters + Actions */}
            <div className="w-full md:flex justify-between flex-wrap gap-4 items-end mt-4 mb-6">
              <div className="md:flex gap-4">
                {/* Date range picker */}
                <div className="min-w-[200px]">
                  <DaterangePicker
                    selectionRange={selectionRange}
                    setSelectionRange={setSelectionRange}
                    style={() => {}}
                  />
                </div>

                {/* City select */}
                <div className="min-w-[180px]">
                  <FormControl fullWidth size="small">
                    <InputLabel id="city-select-label">City</InputLabel>
                    <Select
                      labelId="city-select-label"
                      id="city-select"
                      value={city}
                      label="City"
                      onChange={handleCityChange}
                    >
                      {cities &&
                        Object.entries(cities).map(([key, value]) => (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>

                {/* Hub select */}
                <div className="min-w-[180px]">
                  <FormControl fullWidth size="small">
                    <InputLabel id="hub-select-label">Hub</InputLabel>
                    <Select
                      labelId="hub-select-label"
                      id="hub-select"
                      value={hub}
                      label="Hub"
                      onChange={handleHubChange}
                    >
                      {hubs?.length ? (
                        hubs.map((item, index) => (
                          <MenuItem key={index} value={item?.id}>
                            {item?.hubName}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">
                          <em>Select City First</em>
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>

                <div className="min-w-[250px]">
                  <Autocomplete
                    fullWidth
                    freeSolo
                    options={systemUserData || []}
                    getOptionLabel={(option) => {
                      if (option && typeof option === "object") {
                        const name = option.name || "";
                        const id = option.id || "";
                        const email = option?.email || "";
                        return `${name} - ${email} - ${id}`.trim();
                      }
                      return "";
                    }}
                    value={executiveId}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search by Executive"
                        InputLabelProps={{ shrink: true }}
                        autoComplete="off"
                      />
                    )}
                    onChange={(event, newValue) => {
                      setExecutiveId(newValue);
                    }}
                  />
                </div>
              </div>

              {/* Search & Reset buttons */}
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setDeliveryPage(0);
                    setPickupPage(0);
                    getdeliveryAgentListApi(0, deliveryRowsPerPage);
                    getPickupAgentListApi(0, pickupRowsPerPage);
                  }}
                  className="bg-blue-600 text-white px-6 py-2 rounded-full shadow-md hover:bg-blue-700 transition"
                >
                  Search
                </button>
                <button
                  onClick={handleReset}
                  className="bg-red-400 text-white px-6 py-2 rounded-full shadow-md hover:bg-gray-500 transition"
                >
                  Reset
                </button>
              </div>
            </div>
          </>

          <div className="flex justify-between mt-4">
            <h1 className="text-2xl font-bold my-2">Delivery Agent Lists</h1>
          </div>

          <div className="overflow-y-hidden hide-scrollbar w-full">
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                marginTop: 4,
                boxShadow: 6,
                borderRadius: 2,
                // padding: 2,
              }}
            >
              <TableContainer
                sx={{
                  overflowX: "auto",
                  overflowY: "100%",
                }}
              >
                <Table aria-label="sticky table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          sx={{
                            // border: "1px solid #e0e0e0",
                            // backgroundColor: "#f5f5f5",
                            display: {
                              xs: column.hideOnMobile ? "none" : "table-cell",
                              sm: "table-cell",
                            },
                          }}
                          style={{ minWidth: column.minWidth }}
                          key={column.id}
                          align={column.align || "left"}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingDelivery ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <div className="flex flex-col items-center h-40 justify-center">
                            <BlinkBlur
                              color={[
                                "#cd8032",
                                "#32cd32",
                                "#327fcd",
                                "#cd32cd",
                              ]}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : rows.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <h1 className="mt-10 text-lg font-bold">
                            No Data Found
                          </h1>
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows.map((row, idx) => (
                        <TableRow hover key={idx}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                className="cursor-pointer"
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "action" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      navigate(
                                        `/viewallbookings?bookingid=${row?.bookingcode}&display=true`
                                      );
                                    }}
                                  >
                                    View
                                  </Button>
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={deliveryTotalCount}
                rowsPerPage={deliveryRowsPerPage}
                page={deliveryPage}
                onPageChange={handleDeliveryChangePage}
                onRowsPerPageChange={handleDeliveryChangeRowsPerPage}
              />
            </Paper>
          </div>

          <div className="flex justify-between mt-4">
            <h1 className="text-2xl font-bold my-2">Pickup Agent Lists</h1>
          </div>

          <div className="overflow-y-hidden hide-scrollbar w-full">
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                marginTop: 4,
                boxShadow: 6,
                borderRadius: 2,
                // padding: 2,
              }}
            >
              <TableContainer
                sx={{
                  overflowX: "auto",
                  overflowY: "100%",
                }}
              >
                <Table aria-label="sticky table" stickyHeader>
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          sx={{
                            // border: "1px solid #e0e0e0",
                            // backgroundColor: "#f5f5f5",
                            display: {
                              xs: column.hideOnMobile ? "none" : "table-cell",
                              sm: "table-cell",
                            },
                          }}
                          style={{ minWidth: column.minWidth }}
                          key={column.id}
                          align={column.align || "left"}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingPickup ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <div className="flex flex-col items-center h-40 justify-center">
                            <BlinkBlur
                              color={[
                                "#cd8032",
                                "#32cd32",
                                "#327fcd",
                                "#cd32cd",
                              ]}
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : pickAgentsListData.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={columns.length} align="center">
                          <h1 className="mt-10 text-lg font-bold">
                            No Data Found
                          </h1>
                        </TableCell>
                      </TableRow>
                    ) : (
                      pickAgentsListData.map((row, idx) => (
                        <TableRow hover key={idx}>
                          {columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                className="cursor-pointer"
                                key={column.id}
                                align={column.align}
                              >
                                {column.id === "action" ? (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                      navigate(
                                        `/viewallbookings?bookingid=${row?.bookingcode}&display=true`
                                      );
                                    }}
                                  >
                                    View
                                  </Button>
                                ) : column.format &&
                                  typeof value === "number" ? (
                                  column.format(value)
                                ) : (
                                  value || "-"
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={pickupTotalCount}
                rowsPerPage={pickupRowsPerPage}
                page={pickupPage}
                onPageChange={handlePickupChangePage}
                onRowsPerPageChange={handlePickupChangeRowsPerPage}
              />
            </Paper>
          </div>
        </>
      </div>
    </>
  );
};

export default Deliverypickupagentdashboard;
